import { useNavigate } from "react-router-dom";
import { useResourcesContext, useEmpresa } from "app/contexts";
import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Table } from "app/components/table";
import { Column } from "app/components/column";
import { Row } from "app/components/row";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Container } from "app/components/container";

import toast from "react-hot-toast";

export function EstablecimientosTable() {
  const navigate = useNavigate();

  const { getNombreDeCiudad } = useResourcesContext();
  const { empresa, deleteEstablecimiento } = useEmpresa();

  function handleNext() {
    if (!empresa.establecimientos.length) {
      toast.error("Por favor, agregue al menos un establecimiento");

      return navigate("add");
    }

    return navigate("../../contactos");
  }

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Establecimientos</strong>
            </h5>

            <AddLink to="add" title="Agregar establecimiento" />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.establecimientos.length ? (
            <Table responsive titles={["#", "Tipo", "Ubicación", "Opciones"]}>
              {empresa.establecimientos.map((establecimiento, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td className="text-center">
                    {establecimiento.establecimiento_principal
                      ? "Principal"
                      : "Sucursal"}
                  </td>

                  <td>
                    <div>
                      {getNombreDeCiudad(establecimiento.ciudad_id)}
                      <br />
                      <b>Dirección: </b>
                      {establecimiento.establecimiento_direccion_detallada}
                      <br />
                      <b>Coordenadas: </b>
                      {establecimiento.establecimiento_coordenadas || "N/D"}
                    </div>
                  </td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => {
                          const deleted = deleteEstablecimiento(i);

                          if (deleted) {
                            toast.success("¡Establecimiento eliminado!");

                            return navigate(".");
                          }
                        }}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Por favor, agregue al menos un establecimiento.
            </p>
          )}
        </Column>
      </Row>

      <DFlexResponsive justifyContent="end">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate("../../datos-generales")}
        >
          Anterior
        </button>

        <button type="button" className="btn btn-success" onClick={handleNext}>
          Siguiente
        </button>
      </DFlexResponsive>
    </Container>
  );
}
